import { useNode } from '@craftjs/core';
import {
	SliderControl,
	ToggleButtonGroupControl
} from 'pages/PageEditor/settingsComponents';
import { generateOnChange } from 'pages/PageEditor/settingsComponents/settingsHelpers';
import React, { useMemo } from 'react';
import { BackgroundColor } from './BackgroundColor';
import {
	borderRadiusOptions,
	directionOptions,
	paddingOptions,
	shadowOptions,
	widthOptions
} from './editorContainerSettingsConstants';
import { Spacing } from './Spacing';

const EditorContainerSettings = () => {
	const {
		background,
		paddingX,
		paddingY,
		shadow,
		borderRadius,
		width,
		direction,
		actions: { setProp }
	} = useNode((node) => node.data.props);

	const [
		onPaddingXChange,
		onPaddingYChange,
		onShadowChange,
		onBorderRadiusChange,
		onWidthChange,
		onBackgroundChange,
		onDirectionChange
	] = useMemo(
		() =>
			[
				'paddingX',
				'paddingY',
				'shadow',
				'borderRadius',
				'width',
				'background',
				'direction'
			].map((attr) => generateOnChange(setProp, attr)),
		[setProp]
	);

	return (
		<div>
			<SliderControl
				label={intl.tr('screenEditor.settings.container.width')}
				options={widthOptions}
				setValue={onWidthChange}
				value={width}
				valueLabelDisplay="auto"
				valueLabelFormat={(i: number) => widthOptions[i]}
			/>

			<BackgroundColor
				label={intl.tr('screenEditor.settings.container.fillColor')}
				setValue={onBackgroundChange}
				value={background}
			/>

			<SliderControl
				label={intl.tr('screenEditor.settings.container.shadow')}
				value={shadow}
				options={shadowOptions}
				setValue={onShadowChange}
				marks
			/>

			<SliderControl
				label={intl.tr('screenEditor.settings.container.borderRadius')}
				value={borderRadius}
				options={borderRadiusOptions}
				setValue={onBorderRadiusChange}
				marks
			/>

			<ToggleButtonGroupControl
				options={directionOptions}
				label={intl.tr('screenEditor.settings.container.direction')}
				value={direction}
				setValue={onDirectionChange}
			/>

			<Spacing />

			<SliderControl
				label={intl.tr('screenEditor.settings.container.horizontalPadding')}
				value={paddingX}
				options={paddingOptions}
				setValue={onPaddingXChange}
				marks
			/>
			<SliderControl
				label={intl.tr('screenEditor.settings.container.verticalPadding')}
				value={paddingY}
				options={paddingOptions}
				setValue={onPaddingYChange}
				marks
			/>
		</div>
	);
};

export { EditorContainerSettings };
